import React from 'react';
import {
    Card, CardBody, Progress
} from 'reactstrap';
import moment from 'moment';
import NotificationSystem from 'react-notification-system';
//react-redux comm
import { connect } from 'react-redux';
//import { store } from '../../_helpers';
import SearchPanel from './billedPerAirport-panel';
import PaginatedResult from './billedPerAirport-result';
// styling
import './style.css';

import {commonActions, apiActions, modalActions, alertActions} from '../../_actions';
import {appConstants} from "../../_constants";
import { appHelpers } from '../../_helpers';
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";

import {commonService} from "../../_services";


const Categories = [
	{ label: 'Airline', value: 'AirlineId' },
	{ label: 'Source Airport', value: 'SourceAirportId' },
];



const ViewHeader = () => (
    <div className="view-header d-flex align-items-center">
        <header className="text-white">
            <h1 className="h5 title text-uppercase">Billed Per Airport REPORT</h1>
            {/*<p className="mb-0 subtitle text-nowrap">Post Departure Manifest Comparison Details</p>*/}
        </header>
    </div>
);

const ViewContent = ({children}) => (
    <div className="view-content view-components">
        {children}
    </div>
);

class BilledPerAirport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            catOptions: Categories,
            searchOptions: [],
            url: `${appConstants.PAS_URL}/api/airportbill/newsearch`,
            searchArray:false,
            searchLabelKey: '',
            searchValueKey: '',
            airlines: [],
            airlinesId:'',
            depAirportsId:'',
            flights: [],
            selectValue: { label: 'Airline', value: 'AirlineId' },
            depAirports: [],
            //page error
            contentError: false,  //Errors that affect content on the page
            componentError: false,  //Errors generated within the component
            componentErrorMessages: [],
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux
            //Notification
            notification: {
            // title: 'Default Title',
            message: 'Default Message',
            level: 'success',
            dismissible: true,
            },
            results:false,
            pageSize: 10,
            currentPage: 1,
            totalFlightCounts: 1,
            manifestInfo: false,
            contentErrorText:null,
            clickBD: false,
            manifestLink: '#',
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }


    componentDidMount() {


        this._notificationSystem = this.refs.notificationSystem;
        this.fetchDepAirports();  //    Fetch DepAirport
        this.fetchAirlines();  //    Fetch Airlines

  this.setState({searchOptions:this.state.airlines})
        //Get today's manifests results
        this.handleCatChange({ label: 'Date Type', value: 'DateType' });
    }


    componentDidUpdate(prevProps, prevState) {
        const { clickBD } = this.state;
        if (clickBD) {
            // debugger;
            this.search(1);
            this.setState({ clickBD: false });
        }
    }

    //update selected category
    updateCatValue = (newValue) => {
		this.setState({
			selectValue: newValue
        });
        this.handleCatChange(newValue);
    }

    //populate the multi search options with appropriate category options
    handleCatChange = (option) => {
        if (option) {// incase all category options are remove
            switch (option.value) {
                case 'AirlineId':
                    return this.setState({
                        searchOptions: this.state.airlines,
                        searchLabelKey: 'label',
                        searchValueKey: 'value',
                    });
                case 'SourceAirportId':
                    return this.setState({
                        searchOptions: this.state.depAirports,
                        searchLabelKey: 'label',
                        searchValueKey: 'value',
                    });
                default:
                  return this.state;
              }
        }
        return this.setState({ searchOptions:this.state.airlines });
    }

    // remove option if option in that category is already selected
    switchOptionsPerCategory = (currentArray, newArray, category) => {
        const { selectValue } = this.state;
        let currentCat = (category)? category : selectValue;

        let optionToReplace = currentArray.filter(option => option.cat === currentCat.value)[0];
        // console.log("optionToReplace: " + optionToReplace);

        if (optionToReplace) {
            return newArray.filter(option => option.label !== optionToReplace.label);
        } else {
            return newArray;
        }
    }

    //update selected options categories
    handleSelectChange2 = (newValue, category) => {
        let currentArray = this.state.searchArray;

        //debugger;
        let newArray = (currentArray.length > 0) ? this.switchOptionsPerCategory(this.state.searchArray, newValue, category) : newValue;
        this.setState({ searchArray: newArray });
    }

    fetchAirlines = () => {
        const {dispatch} = this.props;
        this.setState({contentError: false});
        dispatch(apiActions.startFullPageRequest());

        dispatch(commonActions.getAirlinesCarriers())
                .then(() => {
                    const { airlinesCarriers } = this.props;
                  let localAirlines = airlinesCarriers.Results.filter(airline => airline.Carrier === true )
                    this.setState({airlines: this.formatAirlines(localAirlines)});
                    //this.formatAirlines(res.data.Results);
                    dispatch(apiActions.endRequest());
                }).catch(error => {
                    // console.log('Error', error);
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                    this.setState({contentError: errorMessage});
                    dispatch(apiActions.endRequest());
                });
    }

    fetchDepAirports = () => {
        const {dispatch} = this.props;
        this.setState({contentError: false});
        dispatch(apiActions.startFullPageRequest());

        dispatch(commonActions.getDepAirports())
                .then(() => {
                    const { depAirports } = this.props;
                   // let localAirports = depAirports.Results.filter(depAirport => depAirport.IsLocal === true )
                    this.setState({depAirports:this.formatDepartureAirports(depAirports.Results)});
                    dispatch(apiActions.endRequest());
                }).catch(error => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                    this.setState({contentError: errorMessage});
                    dispatch(apiActions.endRequest());
                });
    }


    formatAirlines = (res) => {
        let data = [];

        for (let item of res) {
            item['cat'] = 'AirlineId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Id;
            data.push(item);
        }

        return data;
    };

    formatSearchParameters = (res) => {

        if(res.length > 0) {
            let searchParameters = {};
            res.map(parameter =>
                searchParameters[parameter.cat] = parameter.value
            )
            return searchParameters;
        }
        return {};
    }

    formatDepartureAirports= (res) => {
        let data = [];
        for (let item of res) {
            item['cat'] = 'SourceAirportId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Id;
            data.push(item);
        }

        return data;
    };


    resetError() {
        this.props.dispatch(modalActions.clear());
    }


    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };


    handleAirlineChange = (target) => {
        if(!(target === null && this.state.airlinesId === '')){
            //Get All flights for airline
            let airlineId = (target) ? target.Id : '';
            this.setState({airlinesId : airlineId,contentErrorText:false});
        }
    };
    handleAirportChange = (target) => {
        if(!(target === null && this.state.depAirportsId === '')){
            //Get All flights for airline
            let depAirportsId = (target) ? target.Id : '';
            this.setState({depAirportsId});
        }
    };
    validateInput = () => {
        let formValid = true;
        const {airlinesId} = this.state;
        if(airlinesId === '') {
            formValid = false;
        }
        this.setState({contentErrorText:'Please select airline'});
        return formValid;
    };
    search  = (pageNumber) => {
        if(this.validateInput()){
            this.setState({contentErrorText:false});
            this.handleSearch(pageNumber)
        }
    };
    //Imports
    resetForm() {
        this.setState({contentErrorText:false});
    }
    handleSearch = (pageNumber) => {
        const { dispatch } = this.props;
        const {pageSize, startDate} = this.state;
        this.setState({contentError: false});
        if(pageNumber === undefined){
            dispatch(apiActions.startFullPageRequest());
            pageNumber = 1;
        }else{
            dispatch(apiActions.startRequest());
        }

        let fromPage = pageSize * (pageNumber - 1);

      //  let searchParams = this.formatSearchParameters(searchArray);
        let payload__ = {
            "PageSize": pageSize,
            "From": fromPage,
            "Parameter": {
                StartDate: moment(startDate).format('YYYY-MM-DD'), // + 'T00:00:00.7810902+01:00',
                SourceAirportId:this.state.depAirportsId,
                AirlineId:this.state.airlinesId
            }
        };
        let url = this.state.url;
console.log(url, "urlnow");
            appHelpers.postRequestBIllPerAirport(url, payload__)
                .then((res) => {
                    this.setState({
                        results: (res.data.TotalCount > 0 ? res.data : false),
                        currentPage: pageNumber
                    });
                    dispatch(apiActions.endRequest());
                    this.resetForm();
                })
                .catch((error) => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    //dispatch(alertActions.error(errorMessage));
                    this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                    this.setState({contentError: error.response.data.ErrorMessages})
                });

    };



    renderPageResponse() {
        if(this.state.error){
            return (<div className="alert alert-danger">{this.state.error}</div>);
        }
        else if(this.state.componentError){
            return (<div className="alert alert-danger">{this.state.componentError}</div>);
        }
        else if(this.state.success){
            return (<div className="alert alert-success">{this.state.success}</div>);
        }
    }

    downloadExcel = () => {
        const { dispatch } = this.props;
        const { startDate } = this.state;
      //  let searchParams = this.formatSearchParameters(searchArray);
        const payloadExcel = {
            "PageSize": 100,
            "From": 0,
            "Parameter": {
                SourceAirportId:this.state.depAirportsId,
                AirlineId:this.state.airlinesId,
                StartDate: moment(startDate).format('YYYY-MM-DD') // 'T00:00:00.4919233+01:00'
            }
        };
        commonService.newbilledPerAirportDownloadXls(payloadExcel)
            .then((res) => {
                // console.log(res)
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    // let response = res.response.data.File;
                    let response = res.response.data;
                    console.log(response, "report data");
                    console.log(response.type, "content data");

                    const isBase64 = response.base64File ? true : false;
                    const fileData = response.base64File || response // filestream is in response directly
                    // const mimeType = response.type || "application/pdf";
                    // normalize mime type
        let mimeType = response.type || "application/pdf";
        if (mimeType === "application/xls") {
          mimeType = "application/vnd.ms-excel"; // correct for old .xls
        }
                    appHelpers.downloadFileV2(fileData, "Manifest_Report", isBase64, mimeType);
                    // window.open(response, '_blank');
                    dispatch(apiActions.endRequest());
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }

            });

        dispatch(apiActions.startRequest());
    };

    downloadPdf = () => {
        const { dispatch } = this.props;
        const { startDate } = this.state;
      //  let searchParams = this.formatSearchParameters(searchArray);
        const payloadPdf = {
            "PageSize": 100,
            "From": 0,
            "Parameter": {
                SourceAirportId:this.state.depAirportsId,
                AirlineId:this.state.airlinesId,
                StartDate: moment(startDate).format('YYYY-MM-DD') // 'T00:00:00.4919233+01:00'
            }
        };
        commonService.newbilledPerAirportDownloadPdf(payloadPdf)
            .then((res) => {
            // console.log(res)
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    // let response = res.response.data.File;
                    let response = res.response.data;
                    const isBase64 = response.base64File ? true : false;
                    const fileData = response.base64File || response;
                  
                    // const mimeType = appHelpers.getMimeTypeFromType(downloadType);
                    appHelpers.downloadFileV2(fileData, "Billed_per_airport_Report", isBase64);
                    // window.open(response, '_blank');
                    dispatch(apiActions.endRequest());
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }

            });

        dispatch(apiActions.startRequest());
    };

    render() {
        const {contentErrorText,airlines,depAirports,airlinesId,depAirportsId,results, contentError, currentPage, pageSize } = this.state;
        const { requesting, pageRequesting } = this.props;
        return (
            <div className="view">
                <ViewHeader/>
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        { ((pageRequesting || requesting) && !pageRequesting ) && <Progress striped animated color="success" value={100} className="mb-2"/> }
                        {/*Display loader when component content is dependent on Data from API*/}
                        { (!contentError && pageRequesting) &&
                            <PageLoading/>
                        }

                        {/*Display error when component fail to get Data from API*/}
                        { contentError &&
                        <PageError error={this.state.contentError }/>
                        }

                        {/*Display component content when Data is gotten from API*/}

                        { (!contentError && !pageRequesting) &&
                        <CardBody>
                            <h6 className="mb-4 text-uppercase">Search Panel</h6>
                            <SearchPanel
                                airlines = {airlines}
                                depAirports = {depAirports}
                                contentErrorText={contentErrorText}
                                depAirportsId ={depAirportsId}
                                airlinesId = {airlinesId}
                                handleAirlineChange={this.handleAirlineChange}
                                handleAirportChange={this.handleAirportChange}
                                // categories={catOptions}
                                // selectedCat={selectValue}
                                // multiOptions={searchOptions}
                                // multiLabelKey={searchLabelKey}
                                // multiValueKey={searchValueKey}
                                // multiArray={searchArray}
                                // onCatValueChange={this.updateCatValue}
                                // onMultiValueChange={this.handleSelectChange}
                                onSearch={this.search}
                                startDateChange={startDate => this.setState({ startDate })}
                                 />

                            <CardBody>

                                {(!pageRequesting && results) &&
                                <div>
                                    <PaginatedResult
                                     downloadExcel = {this.downloadExcel}
                                        downloadPdf = {this.downloadPdf}
                                        data={results}
                                        currentPage={currentPage}
                                        pageSize={pageSize}
                                        totalCount={results.TotalCount}
                                    />
                                </div>
                                }
                                {(!pageRequesting && !results) &&
                                <PageEmptyContent message='No record match your search!'/>
                                }
                            </CardBody>
                        </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem"/>
                    </Card>
                </ViewContent>
            </div>
        )
    }

}

function mapStateToProps(state, ownProps) {
    return {
        airlinesCarriers: state.airlinesCarriers,
        depAirports: state.depAirports,
        requesting: state.api.requesting,
        pageRequesting: state.api.pageRequesting,
        modal: state.modal,
    };
}

export default connect(mapStateToProps)(BilledPerAirport);



// WEBPACK FOOTER //
// ./src/views/billedPerAirport/index.js